export default "__VITE_ASSET__222c0f4b__"